import React from 'react';

export default props => {
  return (
    <div className="newark__thank-you-message-container" style={{ backgroundImage: `url(${props.backgroundImage})` }}>
      <div className="newark__thank-you-message-left">
      </div>
      <div className="newark__thank-you-message-right">
        <div className="newark__thank-you-message-image-container">
          <img role="presentation" src={props.image} className="newark__thank-you-message-image"/>
        </div>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkThankYouMessage.js